<template>
  <div v-if="isVisible" class="modal-overlay">
    <div class="modal-content">
      <h2>충전 결과</h2>
      <div class="modal-message" v-html="message"></div>
      <button @click="closeModal" class="modal-button">확인</button>
    </div>
  </div>
</template>

<script setup>
  import { ref, watch } from 'vue'

  const props = defineProps({
    isVisible: Boolean,
    message: String,
  })

  const emit = defineEmits(['update:isVisible'])

  const closeModal = () => {
    emit('update:isVisible', false)
  }
</script>

<style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: var(--device-width);
    max-width: 480px;
    margin: auto;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    background-color: white;
    padding: 1rem;
    border-radius: 12px;
    text-align: center;
    width: 90%;
    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.2);
  }
  .modal-content h2 {
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: var(--font-size-12);
    color: #333;
  }

  .modal-message {
    margin-bottom: 20px;
    white-space: pre-wrap; /* 줄바꿈 적용 */
  }

  .modal-button {
    margin: 10px;
    padding: 0.7rem 1.5rem;
    font-size: var(--font-size-10);
    border: none;
    border-radius: 4px;
    cursor: pointer;
    background-color: #4caf50;
    color: white;
  }

  .modal-button:hover {
    background-color: #45a049;
  }

  :deep(.highlight-code) {
    display: inline-block;
    margin-top: 0.5rem;
    font-weight: bold;
    font-size: var(--font-size-11);
    color: #007bff; /* 강조 색상 */
    background-color: #e9ecef;
    padding: 0.8rem;
    border-radius: 4px;
  }
</style>
